import { MuiThemeProvider } from "@material-ui/core/styles";
import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

import { DarkTheme, LightTheme } from '../themes'

export const FONT_SIZE_BASE = 14;
const FONT_SIZE_HIGH = 20;
const FONT_SIZE_LOW = 10;


const getFontSize = () => {
    const fontSize =  localStorage.getItem('fontSize') || FONT_SIZE_BASE;

     if(fontSize > FONT_SIZE_HIGH){
         return FONT_SIZE_HIGH;
     }

     if(fontSize < FONT_SIZE_LOW){
         return FONT_SIZE_LOW;
     }

     localStorage.setItem('fontSize', fontSize);
     return Number(fontSize);
 }

const ThemeContext = createContext({});

export const useAppThemeContext = ()=>{
    return useContext(ThemeContext)
}

export const AppThemeProvider =  (props) => {
    const currentTheme = localStorage.getItem('theme') || 'light';
    const currentFontSize = getFontSize();    

    const [themeName, setThemeName] = useState(currentTheme);    
    const [fontSize, setFontSize] = useState(currentFontSize);    

    const toggleTheme = useCallback(() => {    
        setThemeName((oldThemeName) => {
            return oldThemeName === "light" ? "dark" : "light"
        });
    }, []);   
    
    const setTheme = useCallback((themeName) => {    
        setThemeName(themeName);
    }, []);   

    const size = useMemo(() => {        
        return fontSize
    }, [fontSize])
    
    const theme = useMemo(() => {

        localStorage.setItem('theme', themeName);
        localStorage.setItem('fontSize', size);
        document.body.setAttribute('data-theme',themeName);
        
        if (themeName === 'light') return LightTheme(size);

        return DarkTheme(size);

    }, [themeName, fontSize]);

   

    const toggleIncFontSize = useCallback(() => {
        setFontSize(oldFontSize => {
            return oldFontSize < FONT_SIZE_HIGH ? parseInt(oldFontSize) + 1 : oldFontSize
        });
        
    }, []);

    const toggleDecFontSize = useCallback(() => {
        setFontSize(oldFontSize => {
            return oldFontSize > FONT_SIZE_LOW ? parseInt(oldFontSize) - 1 : oldFontSize
        });
        
    }, []);  



    return (
        <ThemeContext.Provider value={{ themeName, toggleTheme, setTheme, setFontSize, toggleIncFontSize, toggleDecFontSize, fontSize }}>
            <MuiThemeProvider theme={theme}>                
                    {props.children}                
            </MuiThemeProvider>
        </ThemeContext.Provider>
    )

}